export const feedbackTypeOptions = [{ text: 'General', value: 'general' }, { text: 'Incorrect Rug Status', value: 'database' }]
